// extracted by mini-css-extract-plugin
export var button = "_kl-0";
export var donut = "_kl-1";
export var donutFill = "_kl-3";
export var donutTrack = "_kl-2";